
export default (location, locale) => {
    let l = {};
    if (typeof location === 'string') {
        l.name = location;
    } else {
        l = location;
    }
    const outLocation = {
        ...l,
        name: l.name + '__' + locale
    };

    return outLocation;
};